export default __webpack_public_path__ + "static/media/date_right_icon.2523ca6f.svg";